import Model from '@/models/Model'

export default class PosLastSales extends Model {
  resource() {
    return 'pos_last_sales'
  }
}